import React from "react";
import dayjs from "dayjs";

const inventoryTypeLabels = {
  frame: "Avatar Frame",
  svga: "Admission Car",
  background: "Live Background",
  gift: "Gift",
};

const getInventoryTypeLabel = (type) =>
  inventoryTypeLabels[type] || type || "-";

const getStatus = (inventory) => {
  if (!inventory) {
    return "-";
  }

  if (inventory.expired) {
    return "Expired";
  }

  if (inventory.activated) {
    return "Activated";
  }

  return "Inactive";
};

const getDetails = (inventory) => {
  if (!inventory) {
    return "-";
  }

  return (
    inventory.reason || inventory.message || inventory.validationTag || "-"
  );
};

const formatDate = (value) => {
  if (!value) {
    return "-";
  }

  return dayjs(value).format("MMM D, YYYY h:mm A");
};

const UserInventoryHistory = ({ data }) => {
  return (
    <table className="table table-striped mt-5">
      <thead>
        <tr>
          <th>No.</th>
          <th>Item</th>
          <th>Category</th>
          <th>Quantity/Validity</th>
          <th>Status</th>
          <th>Details</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {data?.length > 0 ? (
          data.map((historyItem, index) => (
            <tr key={historyItem._id || index}>
              <td>{index + 1}</td>
              <td>{historyItem?.inventory?.name || "-"}</td>
              <td>{getInventoryTypeLabel(historyItem?.inventory?.type)}</td>
              <td>
                {historyItem?.inventory?.quantity ||
                  historyItem?.inventory?.validity +
                    " " +
                    historyItem?.inventory?.validityType +
                    "s"}
              </td>
              <td>{getStatus(historyItem?.inventory)}</td>
              <td>{getDetails(historyItem?.inventory)}</td>
              <td>{formatDate(historyItem?.createdAt)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" align="center">
              Nothing to show!!
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default UserInventoryHistory;
